const buttonType = {
    button:'button',
    linkButton:'linkbutton',
    linkButtonWithBorder:'linkbuttonwithborder'
}

export default buttonType;